import styled, { keyframes } from 'styled-components';

export const Container = styled.header`
  background: #f8fafc;
  padding: 18px 28px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 20;
  backdrop-filter: saturate(180%) blur(8px);

  h2 {
    font-size: 1.25rem;
    font-weight: 700;
    margin: 0;
    color: #0f172a;
    letter-spacing: -0.02em;
  }

  .breadcrumb-hint {
    font-size: 12px;
    color: #94a3b8;
    font-weight: 500;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }
`;

export const UserMenuWrapper = styled.div`
  position: relative;
`;

export const UserTrigger = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 999px;
  padding: 4px 10px 4px 4px;
  cursor: pointer;
  transition: all 0.18s ease;

  &:hover {
    background: #ffffff;
    border-color: #e2e8f0;
  }

  &.open {
    background: #ffffff;
    border-color: #cbd5e1;
  }

  &:focus {
    outline: none;
  }

  .info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.2;

    .name {
      font-size: 13px;
      font-weight: 600;
      color: #0f172a;
      letter-spacing: -0.01em;
      max-width: 160px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .role {
      font-size: 11px;
      color: #64748b;
      font-weight: 500;
      text-transform: capitalize;
    }
  }

  @media (max-width: 576px) {
    .info {
      display: none;
    }
  }
`;

export const Avatar = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #006633;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: -0.02em;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0, 102, 51, 0.25);
`;

export const Caret = styled.span`
  color: #94a3b8;
  display: flex;
  align-items: center;
  transition: transform 0.18s ease;

  &.open {
    transform: rotate(180deg);
    color: #006633;
  }
`;

const dropIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-6px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  min-width: 240px;
  background: #ffffff;
  border: 1px solid #eef2f7;
  border-radius: 14px;
  padding: 8px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12),
    0 2px 6px rgba(15, 23, 42, 0.05);
  z-index: 30;
  transform-origin: top right;
  animation: ${dropIn} 0.18s ease;
`;

export const DropdownHeader = styled.div`
  padding: 12px 12px 10px;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 6px;

  .name {
    font-size: 14px;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.01em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .email {
    font-size: 12px;
    color: #64748b;
    margin-top: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const DropdownItem = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: #334155;
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: all 0.15s ease;

  svg {
    color: #64748b;
    flex-shrink: 0;
    transition: color 0.15s ease;
  }

  &:hover {
    background: #f1f5f9;
    color: #0f172a;

    svg {
      color: #0f172a;
    }
  }

  &.danger {
    color: #b91c1c;

    svg {
      color: #b91c1c;
    }

    &:hover {
      background: #fef2f2;
      color: #7f1d1d;

      svg {
        color: #7f1d1d;
      }
    }
  }
`;

export const DropdownDivider = styled.div`
  height: 1px;
  background: #f1f5f9;
  margin: 6px 4px;
`;
